import reducer from './selfUserReducer';
import actions from './selfUserActions';
import createProvider from '../../utilities/createProvider';

export default createProvider(actions, reducer);
